import { JSX } from 'react'

import { IconProps } from '../../icon'

const Warning: (props: IconProps) => JSX.Element = ({
  dataTestId,
  fill,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill={fill}
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M40.2691 30.9569L28.6566 12.9989C27.8476 11.7456 26.4833 11 24.9921 11C23.5009 11 22.1366 11.7456 21.3275 12.9989L9.71508 30.9569C8.8267 32.3212 8.76324 33.9869 9.54058 35.4146C10.3179 36.8424 11.7457 37.699 13.3797 37.699H36.6203C38.2385 37.699 39.6821 36.8424 40.4594 35.4146C41.2368 33.9869 41.1733 32.3212 40.2849 30.9569H40.2691ZM38.3495 34.2724C38.0005 34.9228 37.3501 35.3036 36.6045 35.3036H13.3797C12.634 35.3036 11.9836 34.9228 11.6346 34.2724C11.2856 33.622 11.3173 32.8605 11.7139 32.2418L23.3264 14.2838C23.6912 13.7127 24.3099 13.3796 24.9921 13.3796C25.6742 13.3796 26.277 13.7127 26.6578 14.2838L38.2702 32.2418C38.6668 32.8605 38.6985 33.622 38.3495 34.2724Z'
      fill={fill}
    />
    <path
      d='M24.992 28.1648C25.6425 28.1648 26.1818 27.6254 26.1818 26.975V19.043C26.1818 18.3926 25.6425 17.8532 24.992 17.8532C24.3416 17.8532 23.8022 18.3926 23.8022 19.043V26.975C23.8022 27.6254 24.3416 28.1648 24.992 28.1648Z'
      fill={fill}
    />
    <path
      d='M25.0238 30.5444C24.3734 30.5444 23.834 31.0838 23.834 31.7342C23.834 32.3846 24.3734 32.924 25.0238 32.924C25.6743 32.924 26.2136 32.3846 26.2136 31.7342C26.2136 31.0838 25.6901 30.5444 25.0238 30.5444Z'
      fill={fill}
    />
  </svg>
)

export default Warning
